module.exports = __webpack_public_path__ + "static/media/scripting.1f89ba70.jpg";